import { StarbaseDataService } from 'starbase-launcher';
import { LUSource } from '../models/luSource';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, retry, publishReplay, refCount, take } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
    providedIn: 'root'
})
export class LUSourceService extends StarbaseDataService<LUSource> {

    sourceCache: Observable<LUSource>[];

    protected _staleDataTimeout = 30000;
    protected _getOneUri = '/api/LU_SourceModels/';
    protected _getAllUri = '/api/LU_SourceModels';
    protected _postUri = '/api/LU_SourceModels';
    protected _putUri = '/api/LU_SourceModels/';
    protected _deleteUri = '/api/LU_SourceModels/';
    protected _broadSearchUri: string;

    constructor(private httpX: HttpClient, private webApiX: WebApiService) {
        super(httpX, webApiX);
        this.sourceCache = [];
    }

    public getData(url: string, sourceId: number) {
        if (!sourceId) {
            return of(null);
        }
        // return cached entity if data is available
        if (this.sourceCache && this.sourceCache[+sourceId]) {
            return this.sourceCache[+sourceId];
        }
        this.sourceCache[+sourceId] = this.httpX.get<LUSource>(
            this.server + this.getOneUri + sourceId.toString(),
            { headers: this.webApiX.getApiHeaders('get') }
        ).pipe(
            retry(this.defaultRetries),
            catchError(e => this.webApiX.handleRequestError(e)),
            publishReplay(1),
            refCount(),
            take(1)
        );
        return this.sourceCache[sourceId];
    }

}
